"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOperation = exports.performTransform = exports.validateTransform = exports.parsePyExtractionParams = exports.parsePyExtractValueParams = exports.parsePyConvertRangeParams = void 0;
const common_1 = require("@finley-technologies/common");
const errorUtils_1 = require("./errorUtils");
const parsePyConvertRangeParams = (transformation) => {
    const errors = [];
    let columns;
    let numRows;
    let headerRow;
    let headerRowNumber = null;
    let dataEndRowNumber = null;
    const { isSheetNameRegex, headerRange, dataEndRange, sheetName, } = transformation;
    if (isSheetNameRegex) {
        errors.push(`SheetNameRegex is not supported in pyXlsx2Csv2.`);
    }
    const [headerRangeStart, headerRangeEnd] = headerRange.split(':');
    if (headerRangeStart && headerRangeEnd) {
        const { c: headerStartCol, r: headerStartRow, } = common_1.utils.excelCoordsToNumberCoords(headerRangeStart);
        const { c: headerEndCol, r: headerEndRow, } = common_1.utils.excelCoordsToNumberCoords(headerRangeEnd);
        if (headerStartRow === headerEndRow) {
            headerRowNumber = headerStartRow;
            headerRow = headerStartRow;
        }
        else {
            errors.push('pyXlsx2Csv only supports headers in a single row.');
        }
        const headerStartColLetter = common_1.utils.numberToExcelLetter(headerStartCol);
        const headerEndColLetter = common_1.utils.numberToExcelLetter(headerEndCol);
        columns = `${headerStartColLetter}:${headerEndColLetter}`;
    }
    else {
        errors.push('Header range must be defined in format of A1:Z2');
    }
    if (dataEndRange) {
        const [dataEndRangeStart, dataEndRangeEnd] = dataEndRange.split(':');
        if (dataEndRangeStart && dataEndRangeEnd) {
            const { r: dataEndRangeStartRow } = common_1.utils.excelCoordsToNumberCoords(dataEndRangeStart);
            const { r: dataEndRangeEndRow } = common_1.utils.excelCoordsToNumberCoords(dataEndRangeEnd);
            if (dataEndRangeStartRow === dataEndRangeEndRow) {
                dataEndRowNumber = dataEndRangeStartRow;
            }
            else {
                errors.push('Data end range must be a single row.');
            }
        }
        else {
            errors.push('Data end range must be defined in format of A2:Z2.');
        }
    }
    if (typeof headerRowNumber === 'number' &&
        typeof dataEndRowNumber === 'number') {
        if (dataEndRowNumber >= headerRowNumber) {
            // dataEndRowNumber is the last row, inclusive, so when taking the
            // difference we add one to get the true number of rows.
            numRows = dataEndRowNumber - headerRowNumber + 1;
        }
        else {
            errors.push(`[dataEndRowNumber:${dataEndRowNumber}] must be greater than or equal to [headerRowNumber:${headerRowNumber}]`);
        }
    }
    if (errors.length) {
        return {
            errors,
            isValid: false,
        };
    }
    return {
        isValid: true,
        pyXlxs2CsvExtractionParams: {
            sheetName,
            columns,
            numRows,
            headerRow,
            values: undefined,
        },
    };
};
exports.parsePyConvertRangeParams = parsePyConvertRangeParams;
const parsePyExtractValueParams = (transformation) => {
    return {
        isValid: true,
        pyXlxs2CsvExtractionParams: {
            sheetName: transformation.sheetName,
            columns: undefined,
            numRows: undefined,
            headerRow: undefined,
            values: transformation.fields.map(({ field, cellAddress }) => {
                const coords = common_1.utils.excelCoordsToNumberCoords(cellAddress);
                return { name: field, rowIndex: coords.r, columnIndex: coords.c };
            }),
        },
    };
};
exports.parsePyExtractValueParams = parsePyExtractValueParams;
const parsePyExtractionParams = (transformation) => {
    switch (transformation.mode) {
        case 'convertRange':
            return (0, exports.parsePyConvertRangeParams)(transformation);
        case 'extractValues':
            return (0, exports.parsePyExtractValueParams)(transformation);
        default:
            throw (0, common_1.finleyAssertUnreachable)(transformation);
    }
};
exports.parsePyExtractionParams = parsePyExtractionParams;
const validateTransform = (transformation) => {
    const result = (0, exports.parsePyExtractionParams)(transformation);
    if (!result.isValid) {
        const errors = result.errors.map((err) => ({
            type: 'metadataValidation',
            message: err,
        }));
        return {
            isValid: false,
            errors,
        };
    }
    return {
        isValid: true,
        data: null,
    };
};
exports.validateTransform = validateTransform;
const performTransform = async ({ buffersWithExtensions, transformation, pyXlsx2Csv2Extractor, }) => {
    try {
        (0, common_1.finleyAssert)(pyXlsx2Csv2Extractor, 'pyXlsx2Csv2Extractor is required');
        (0, common_1.finleyAssert)(buffersWithExtensions.length === 1, 'Only one data tape is supported');
        const extractionParamsResult = (0, exports.parsePyExtractionParams)(transformation);
        (0, common_1.finleyAssert)(extractionParamsResult.isValid, 'Invalid transformation params');
        const res = await pyXlsx2Csv2Extractor({
            extractionParams: extractionParamsResult.pyXlxs2CsvExtractionParams,
            excelBuffer: buffersWithExtensions[0],
        });
        return res;
    }
    catch (error) {
        return (0, errorUtils_1.convertErrorToTapeFailureResult)(error, 'pyXlsx2Csv2: ');
    }
};
exports.performTransform = performTransform;
exports.transformOperation = {
    operation: 'pyXlsx2Csv2',
    validateTransform: exports.validateTransform,
    performTransform: exports.performTransform,
};
//# sourceMappingURL=pyXlsx2Csv2-transform.js.map